import { EmptyProps, EmptyView } from '@components'

import { ReactElement, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { Scope } from '../../../../enums/scope'
import { isAuthorized } from '../../../../utils/isAuthorized'

interface ContactBalanceEmptyProps extends EmptyProps {
  path: string
}

export const ContactBalanceEmpty = ({
  animation,
  buttonText,
  description,
  title,
  path,
}: ContactBalanceEmptyProps): ReactElement => {
  const navigate = useNavigate()
  const shouldSeeCreateButton = isAuthorized(Scope.InvoiceWrite)

  const handleEmptyViewClick = useCallback(() => {
    if (path) {
      navigate(path)
    }
  }, [navigate, path])

  return (
    <EmptyView
      animationName={animation}
      onClick={handleEmptyViewClick}
      tButton={buttonText}
      tDescription={description}
      tTitle={title}
      showCTA={shouldSeeCreateButton}
    />
  )
}
